import { ProfileState } from '~/store/types/profile';

import {
  BlackFridayProductId,
  UserExtraFieldKeyBlackFriday,
} from '../constants';

const isShowModalForProfile = (profile: ProfileState): boolean => {
  return (
    profile.isLoggedIn &&
    !profile.extra_fields?.notifications?.[UserExtraFieldKeyBlackFriday] &&
    !profile.is_stripe_user &&
    profile.user_product.id !== BlackFridayProductId
  );
};

export default isShowModalForProfile;
